function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var HiAppPrepaid = function HiAppPrepaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M14.21 1c.813 0 1.582.304 2.165.854L20.85 6.09a2.97 2.97 0 0 1 .932 2.146V20c0 1.654-1.452 3-3.237 3H6.237C4.452 23 3 21.654 3 20V4c0-1.654 1.452-3 3.237-3zm0 2H6.236C5.555 3 5 3.448 5 4v16c0 .552.555 1 1.237 1h12.307c.682 0 1.237-.448 1.237-1V8.236a.95.95 0 0 0-.308-.694L15 3.308A1.16 1.16 0 0 0 14.21 3m2.35 11.252a.94.94 0 0 1 .656.264.943.943 0 0 1 .264.656.93.93 0 0 1-.264.655.91.91 0 0 1-.656.265.914.914 0 0 1-.655-.265.928.928 0 0 1-.265-.655.94.94 0 0 1 .265-.656.928.928 0 0 1 .655-.264m-8.53-5.78v3.36h.021a.9.9 0 0 1 .169-.28q.121-.14.29-.25a1.6 1.6 0 0 1 .401-.18q.229-.07.5-.07.57 0 .92.175t.545.484.264.732q.07.418.071.909v2.68h-1.5v-2.38q0-.21-.016-.435a1.4 1.4 0 0 0-.09-.415.7.7 0 0 0-.229-.31q-.155-.12-.446-.12a.93.93 0 0 0-.469.104.73.73 0 0 0-.276.28 1.2 1.2 0 0 0-.125.396q-.03.22-.03.46v2.42h-1.5v-7.56zm5.76 2.7v4.86h-1.5v-4.86zm3.52-2.22v4.74h-1.5v-4.74zm-4.27-.18q.36 0 .615.255t.255.614a.84.84 0 0 1-.255.616.84.84 0 0 1-.615.255.84.84 0 0 1-.614-.255.84.84 0 0 1-.255-.616q0-.359.255-.614a.84.84 0 0 1 .614-.255"
  }));
};
export default HiAppPrepaid;